<template>
  <div class="usage-notice">
    <p>欢迎您使用快影模板师平台（以下简称“本平台”）申请成为模板模板师！</p>
    <p>
      为了更好地为您提供服务，请您仔细阅读并充分理解《快影模板师平台使用须知》（以下简称“本协议”），本协议是快影《用户服务协议》的重要组成部分，<span
        class="bold underline"
        >您在线完成快影用户注册并使用快影平台服务时，即为您已确认理解、同意并适用快影《用户服务协议》以及其他相关规则</span
      >。请您务必认真阅读并充分理解本协议，<span class="bold"
        >特别是涉及免除或者限制责任的条款、内容规范、权利许可、法律适用和争议解决条款等</span
      >。
    </p>
    <p>
      除非您已阅读并接受本协议及相关协议的所有条款，否则请您不要使用本平台进行快影模板师申请。您通过本服务进行申请提交的行为即视为您已阅读并同意本协议的约束，且具有使用本平台的相应权利能力和行为能力，并可以对自己的行为承担法律责任。
    </p>
    <p class="title">一、本协议的范围</p>
    <p>
      1.&emsp;欢迎您使用本平台申请成为模板模板师，申请通过后您的快影账号将具备模板上传权限，且您同意授权快影及其用户使用您的原创模板素材。本平台的相关服务由北京快手科技有限公司（以下简称“公司”或“我们”或“被授权人”）为您提供。
    </p>
    <p>
      2.&emsp;快影是一款专业视频拍摄、视频剪辑和视频制作的工具，应用内具有海量的模板、丰富的音乐库供用户进行视频的编辑与制作。快影公司是提供信息网络存储空间的网络服务提供者。
    </p>
    <p>
      3.&emsp;凡在本平台申请成为模板师、上传并授权本平台使用您的原创模板内容的模板师（以下简称“您”或“授权人”），均需确认并同意本协议，您通过网络阅读本协议全文并点击“开始申请”项后，本协议对协议各方当事人产生法律约束力。
    </p>
    <p class="title">二、声明与保证</p>
    <p>
      1.&emsp;授权人确认，授权作品为授权人自行创作的模板，未使用未经授权的音频、图片、视频及字体等。授权人保证自己享有或已经从合法渠道获得所创作模板、使用音乐等元素并通过网络传播的权利，且本人为原创模板模板师或已经从合法渠道征得模板模板师的同意。<span
        class="bold"
        >授权人同意，若被授权人收到权利人通知，主张授权内容侵犯其相关权利的，有权进行独立判断并采取删除、屏蔽或断开链接等措施。如您认为相关通知有误，您应当提供充分的反通知证明材料，本平台经核实后将解除相关限制措施，恢复移除的作品</span
      >。
    </p>
    <p>
      2.&emsp;授权人保证：授权人是授权作品著作权和邻接权的合法所有者或完整授权人，享有对外授权所必须的任何及全部权利/许可。授权人保证授权作品合法合规，不包含暴力、色情、侮辱诽谤他人、危害国家安全、破坏宗教政策等敏感、违规内容。
    </p>
    <p>
      3.&emsp;上传模板文件不包含任何损坏文档、病毒、蠕虫、木马或其他类似损害程序代码的内容，否则由此造成的损失由您承担。
    </p>
    <p class="bold">
      4.&emsp;授权人在快影内的行为和发布的内容需要遵守本协议、快影《用户服务协议》和相关法律法规的规定。不得制作、复制、发布、传播含有下列内容的信息：
    </p>
    <p class="bold">（1）反对宪法所确定的基本原则；</p>
    <p class="bold">
      （2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一；
    </p>
    <p class="bold">（3）损害国家荣誉和利益；</p>
    <p class="bold">（4）煽动民族仇恨、民族歧视，破坏民族团结；</p>
    <p class="bold">（5）破坏国家宗教政策，宣扬邪教和封建迷信；</p>
    <p class="bold">（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
    <p class="bold">
      （7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪；
    </p>
    <p class="bold">（8）侮辱或者诽谤他人，侵害他人合法权益；</p>
    <p class="bold">（9）含有法律、行政法规禁止的其他内容。</p>
    <p>
      5.&emsp;您充分知晓并保证您对在本平台上传、发布的内容享有合法权益，若发布的内容发生权利纠纷或侵犯了任何第三方的合法权益，由您承担全部法律责任。
    </p>
    <p>
      6.&emsp;由于您的账户行为（包括但不限于在线签署各类协议、发布信息/原创模板等）均代表您本人行为，您应妥善保管您的账户信息及密码并对您的账户行为的结果负责。<span
        class="bold"
        >同时您也应保证不主动将账户出借、赠与、出租、转让、售卖或以其他方式许可他人使用，如果违背该等承诺，快影平台有权采取包括模板下架、取消模板现金评级资格、暂停或取消模板创作权限等举措。对屡次违反或造成恶劣影响的，快影将采取封禁账号等处理措施</span
      >。
    </p>
    <p class="title">三、知识产权声明</p>
    <p class="bold">
      1.&emsp;授权人同意，将通过本平台上传、发布的所有模板作品（以下统称为”授权内容”）的著作权及邻接权中的信息网络传播权、复制权、汇编权、改编权等权利在全球范围内授权被授权人及其关联公司使用，允许被授权人及其用户对您上传的模板类作品进行剪辑、编辑等二次创作或分享至其他网络平台传播、宣传推广及展示此等授权内容。授权人明确知悉授权人拥有上述权利或已从原始权利人或其他相关权利人处获得以上权利并有权进行转授权是授权人能够签署本协议的前提。
    </p>
    <p>
      2.&emsp;上述授权的使用范围包括被授权人以及被授权人关联公司运营或合作的产品，包括但不限于快影APP、短视频分享及直播平台【快手】品牌APP（包括但不限于快手短视频网站（kuaishou.com）以及快手APP、快手概念版APP、快手极速版APP、云视听快TV等视频播放软件现有及未来运营或合作的平台），以及皮艇APP、一甜相机APP、AcFun
      弹幕网以及相应移动端APP、水母APP、快看点APP、Before避风等客户端应用软件（包括iOS、Android和其他任何操作系统版本）及对应网站）。
    </p>
    <p>3.&emsp;授权区域：全世界范围。</p>
    <p>
      4.&emsp;授权性质：授权人授予被授权人对授权内容免费的非独占授权。即授权人依然是授权内容的权利人，仍有将授权内容授权给其他第三方内容分享平台、进行各种商业行为并获取利益的权利。
    </p>
    <p>5.&emsp;授权期限：自本协议生效之日起永久</p>
    <p class="bold">
      6.&emsp;公司对于您上传的模板内容可能存在的审核并不意味着公司对该内容合法性的任何承诺或担保，也不构成公司与您或您上传作品的任何连带责任，公司仅作为网络服务提供者为您提供网络储存空间，您需要对您上传的作品独立负责。
    </p>
    <p class="title">四、侵权投诉及反通知</p>
    <p>
      在快影平台告知您或您自行得知您存在侵犯他人合法权益情形后，您应根据快影平台的相应规定向快影平台提出反通知（您理解和同意：为了更好地维护您和投诉人的合法权益，在快影平台通过邮箱向您在本平台登记的邮箱或以其他方式，将您上传的模板作品被投诉的信息告知您后，若您未在3个工作日内向快影平台邮箱提交反通知的，则视为您对于投诉表示认可）。但是，无论快影平台是否告知您、您是否提出反通知或反通知是否符合相关法规、快影平台要求等，均不影响快影平台进行自己的独立判断和随时采取相关措施。
    </p>
    <p class="title">五、其他</p>
    <p>
      1.&emsp;公司有权在必要时修改本协议条款。您可以在相关服务页面查阅最新版本的条款。本协议条款变更后，如果您继续使用快影模板师平台服务，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本平台的模板上传、发布等服务。
    </p>
    <p>
      2.&emsp;本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。
    </p>
    <p class="bold">
      3.&emsp;若您和我们之间发生任何纠纷或争议，双方应首先友好协商；协商不成的，应向被授权人住所地有管辖权的人民法院提起诉讼。
    </p>
    <p>
      4.&emsp;本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
    </p>
  </div>
</template>
<script>
export default {
  name: 'usage-notice',
  setup() {
    useHead({
      script: [{ src: '/js/flexible.js', type: 'text/javascript' }],
    })
  },
  data() {
    return {}
  },
  created() {
    document.title = '快影模板师平台使用须知'
  },
}
</script>
<style lang="less" scoped>
.usage-notice {
  background-color: #fff;
  padding: 0.2rem 0.3rem;
  font-family: PingFangSC-Regular;
  font-size: 0.26rem;
  line-height: 0.44rem;
  color: rgba(0, 0, 0, 0.9);
  .title {
    margin-top: 0.5rem;
    font-weight: bold;
  }
  .bold {
    font-weight: bold;
  }
  .underline {
    text-decoration: underline;
  }
}
</style>
